import {
    SET_FIRST_NAME,
    SET_LAST_NAME,
    SET_EMAIL,
    SET_PHONE,
    SET_DELIVERY_OPTION,
    SET_STORE_LOCATION
} from 'Actions/payment';

const initialState = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    deliveryOption: "outsideStore",
    storeLocation: 1
}

export default function payment(state = initialState, action) {
    switch (action.type) {
        case SET_FIRST_NAME:
            return { ...state, firstName: action.first_name };
        case SET_LAST_NAME:
            return { ...state, lastName: action.last_name };
        case SET_EMAIL:
            return { ...state, email: action.email };
        case SET_PHONE:
            return { ...state, phone: action.phone };
        case SET_DELIVERY_OPTION:
            return { ...state, deliveryOption: action.deliveryOption };
        case SET_STORE_LOCATION:
            return { ...state, storeLocation: action.location };
        default:
            return state;
    }
};